import type { ReactNode } from 'react';
import type { IconName } from '../icons';
import { Icon } from './Icon';

export function InlineMessage(props: { kind: 'ok' | 'err' | 'info'; text: string }) {
  return <p className={`msg msg-${props.kind}`}>{props.text}</p>;
}

// Full-width tinted notice with an icon: a fact about the current state (inspection locked, working
// offline on a remembered session, AI not available in this build) — never a placeholder.
export function Banner(props: { tone?: 'info' | 'warning' | 'error' | 'success'; icon?: IconName; title: string; body?: string; action?: ReactNode; testId?: string }) {
  const tone = props.tone ?? 'info';
  return (
    <div className={`banner banner-${tone}`} role="status" data-testid={props.testId}>
      {props.icon ? <Icon name={props.icon} /> : null}
      <div className="banner-main">
        <p className="banner-title">{props.title}</p>
        {props.body ? <p className="banner-body">{props.body}</p> : null}
      </div>
      {props.action ? <div className="banner-action">{props.action}</div> : null}
    </div>
  );
}
